import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../Components/Loader";

const TrailerPage = ()=>{
    const trailer = useSelector(state=>state.TrailerReducer);
    const [trailerKey,setTrailerKey] = useState('1mTjfMFyPi8');
    const {isMovie} = useSelector(state=>state.DetailsReducer);
    useEffect(()=>{
        if(trailer.length>0){

            const newTrailer = trailer.filter(item=>{
                if(item.type==='Trailer'){
                    return item;
                }
                return null
            })
            console.log(trailer);
            
            setTrailerKey((isMovie)?trailer[0].key:newTrailer[0].key||trailer[0].key)
        }
    },[trailer,isMovie])
    return <div className="pt-12 flex flex-row justify-center items-center lg:px-8 md:px-4 px-2 dark:bg-secondary-dark min-h-screen">
        {
        (trailer.length>0)?
        <iframe width="100%" height="500" src={`https://www.youtube.com/embed/${trailerKey||'1mTjfMFyPi8'}`}title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen autoPlay ></iframe>
        :
        <Loader/>
        }
       
    </div>
}

export default TrailerPage;